export default "__VITE_PUBLIC_ASSET__9fb02ca3__"